/* eslint jsx-a11y/anchor-is-valid: 0 */

import React, {useState, useEffect} from "react";
import {
  Alert,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  FormCheckbox,
  FormSelect,
  ListGroup,
  ListGroupItem,
  Col,
  Form,
  FormFeedback,
  Button,
  FormInput,
  FormTextarea,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Badge,
} from "shards-react";
import {useParams} from "react-router-dom";
import { getUserLocale } from 'get-user-locale';
//import 'react-flags-select/css/react-flags-select.css';
import PageTitle from "../../components/common/PageTitle";
import { accessCheck } from "../../utils/tools";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faTimes } from '@fortawesome/free-solid-svg-icons';

const language = (getUserLocale() && getUserLocale().length === 5) ? getUserLocale() : 'en_US';
const locale = language.substr(-2).toLowerCase();

const EditUser = (props) => {
  let {userId} = useParams();
  const [user, setUser] = useState(props.users.find(user => user.id === userId));
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [client, setClient] = useState(() => {
    if (props.user.type === 'super') {
      return null;
    } else if (props.user.type === 'regional') {
      return props.user.client;
    } else {
      return props.clients[0]?.id || null;
    }
  });
  const [type, setType] = useState(() => {
    if (props.user.type === 'regional') {
      return 'officer';
    }
    return 'admin';
  });
  const [active, setActive] = useState(true);
  const [stripeRefunds, setStripeRefunds] = useState(false);
  const [validName, setValidName] = useState(null);
  const [validEmail, setValidEmail] = useState(true);
  const [validPassword, setValidPassword] = useState(null);
  const params = (new URL(document.location)).searchParams;
  const returnTo = params.get('return-to')
  const [footerText, setFooterText] = useState('')
  const [citationTerm, setCitationTerm] = useState('Parking Violation')
  const [warningTerm, setWarningTerm] = useState('Violation Warning')
  const [firstParagraph, setFirstParagraph] = useState('')
  const [parklyncApiKey, setParklyncApiKey] = useState(null)
  const [assignedLocations, setAssignedLocations] = useState([])
  const [selectedLocation, setSelectedLocation] = useState('')

  useEffect(() => {
    document.title = 'Users: EnforcePlus admin';
    !accessCheck(props.user, 'users') && (window.location.href = '/')
  }, [])

  // Users links here via full page reload, so props.users comes from the
  // redux-persist snapshot, which can be stale or empty — refetch instead.
  useEffect(() => {
    if (userId) {
      props.getUsers()
    }
  }, [userId])

  // Same for clients: the persisted list is whatever Users last loaded, which
  // after impersonating is that one client.
  useEffect(() => {
    props.getClients()
  }, [])

  useEffect(() => {
    if (user) {
      setName(user.name || '')
      setEmail(user.email || '')
      setClient(user.client || null)
      setType(user.type || 'admin')
      setActive(!!user.active)
      setStripeRefunds(!!user.stripe_refunds)
      setValidName(user.name.length > 2)
      setValidEmail(() => validateEmail(user.email))
      // Load assigned locations for regional admins
      if (user.type === 'regional' && user.assignedLocations) {
        setAssignedLocations(user.assignedLocations)
      }
    }
  }, [user])

  useEffect(() => {
    if (userId) {
      setUser(props.users.find(user => user.id === userId))
    }
  }, [props.users, userId])

  const validateEmail = (email) => {
    let valid = false;
    if (email.length > 0) {
      valid = (/^\w+([.\+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email))
    }
    if (props.users.find(thisUser => thisUser.email.toLowerCase() === email.toLowerCase() && thisUser.id !== user?.id)) {
      valid = false;
    }
    return valid
  }

  const validatePassword = (password) => {
    if (password.length > 7) {
      return true
    }
    return false
  }

  return (
    <Container fluid className="main-content-container px-0">
      <Container fluid className="main-content-container px-4">
        {/* Page Header */}
        {!props.removeTitles && (
          <Row noGutters className="page-header py-4">
            <Col xs="12" sm="8">
              <PageTitle sm="12" title={(userId ? 'Edit' : 'Add') + ' User'} subtitle={'Users'} className="text-sm-left" />
            </Col>
          </Row>
        )}
        {/* First Row of Posts */}
        <Row>
          <Col className="mb-4">
            <Card className={'mb-0'}>
              <Container fluid>
                <Row>
                  <Col lg={6}>
                    <ListGroup flush>
                      <ListGroupItem className="p-3">
                        <Row>
                          <Col>
                            <Form>
                              <Row form>
                                <Col md="12" className="form-group">
                                  <label htmlFor="feName">Name</label>
                                  <FormInput
                                    id='feName'
                                    onChange={event => setName(event.target.value)}
                                    placeholder='Name'
                                    value={name}
                                    invalid={validName === false}
                                    onBlur={() => setValidName(name.length > 2)}
                                  />
                                  <FormFeedback>Please enter a valid name.</FormFeedback>
                                </Col>
                              </Row>               
                            </Form>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Form>
                              <Row form>
                                <Col md="12" className="form-group">
                                  <label htmlFor="feEmail">Email address</label>
                                  <FormInput
                                    id='feEmail'
                                    onChange={event => setEmail(event.target.value)}
                                    placeholder='Email address'
                                    value={email}
                                    invalid={validEmail === false}
                                    disabled={user?.id && props.user.id !== user?.id}
                                    onBlur={() => setValidEmail(() => validateEmail(email))}
                                  />
                                  <FormFeedback>Invalid email address or email already in use.</FormFeedback>
                                  {user?.id && props.user.id !== user?.id && (
                                    <p style={{marginBottom: 8, marginTop: 4}}>Note: You can only edit your own email address. App only users will need to use the app to change their email.</p>
                                  )}
                                </Col>
                              </Row>               
                            </Form>
                          </Col>
                        </Row>
                        {(!user || !user.id) && (
                          <Row>
                            <Col>
                              <Form>
                                <Row form>
                                  <Col md="12" className="form-group">
                                    <label htmlFor="fePassword">Set password</label>
                                    <FormInput
                                      id='fePassword'
                                      type={'password'}
                                      onChange={event => setPassword(event.target.value)}
                                      placeholder='Password'
                                      value={password}
                                      invalid={validPassword === false}
                                      onBlur={() => setValidPassword(() => validatePassword(password))}
                                    />
                                    <FormFeedback>Password must be a minimum of 8 characters.</FormFeedback>
                                  </Col>
                                </Row>               
                              </Form>
                            </Col>
                          </Row>
                        )}
                        <Row>
                          <Col>
                            <Form>
                              <Row form>
                                <Col md="12" className="form-group">
                                  <label htmlFor="feRole">Role</label>
                                  <FormSelect id="feRole" value={type} onChange={event => {
                                    setType(event.target.value);
                                    console.log('Role selected:', event.target.value);
                                  }}>
                                    {props.user.type === 'super' && (
                                      <option value={'super'}>Super Admin</option>
                                    )}
                                    {(props.user.type === 'super' || props.user.type === 'admin') && (
                                      <option value={'admin'}>Admin</option>
                                    )}
                                    {(props.user.type === 'super' || props.user.type === 'admin') && (
                                      <option value={'regional'}>Regional Admin</option>
                                    )}
                                    {(props.user.type === 'super' || props.user.type === 'admin') && (
                                      <option value={'citation_admin'}>Citation Admin</option>
                                    )}
                                    {(props.user.type === 'super' || props.user.type === 'admin' || props.user.type === 'regional') && (
                                      <option value={'officer'}>Enforcement officer</option>
                                    )}
                                  </FormSelect>
                                </Col>
                              </Row>               
                            </Form>
                          </Col>
                        </Row>
                        {props.user.type === 'super' && type !== 'super' && (
                          <Row>
                            <Col>
                              <Form>
                                <Row form>
                                  <Col md="12" className="form-group">
                                    <label htmlFor="feClient">Client</label>
                                    <FormSelect id="feClient" value={client} onChange={event => setClient(event.target.value)}>
                                    <option value={null}>Select</option>
                                      {props.clients.filter(client => ((!user || !user.id) && client.active) || (user && user.id && client)).sort((a, b) => a.name.localeCompare(b.name)).map(client => (
                                        <option value={client.id}>{client.name}</option>
                                      ))}
                                    </FormSelect>
                                  </Col>
                                </Row>               
                              </Form>
                            </Col>
                          </Row>
                        )}
                        <Row>
                          <Col>
                            <Form>
                              <Row form>
                                <Col md="12" className="form-group">
                                  <label htmlFor="feName">Active</label>
                                  <FormCheckbox
                                      toggle
                                      checked={active}
                                      onChange={() => setActive(!active)}
                                    >
                                  </FormCheckbox>
                                </Col>
                              </Row>
                              {/* OOB-540: refund capability in the Stripe payments dashboard is
                                  per user, not per location. Only a super admin can grant it. */}
                              {props.user?.type === 'super' && (type === 'admin' || type === 'super') && (
                                <Row form>
                                  <Col md="12" className="form-group">
                                    <label htmlFor="feStripeRefunds">Stripe refunds and dispute responses</label>
                                    <FormCheckbox
                                        id="feStripeRefunds"
                                        toggle
                                        checked={stripeRefunds}
                                        onChange={() => setStripeRefunds(!stripeRefunds)}
                                      >
                                    </FormCheckbox>
                                    <small className="text-muted">
                                      Off: the payments dashboard is read-only for this user. On: they can issue
                                      refunds and respond to disputes. Super admins always have it.
                                    </small>
                                  </Col>
                                </Row>
                              )}
                            </Form>
                          </Col>
                        </Row>
                        
                        {/* Location Assignment for Regional Admins */}
                        {type === 'regional' && (
                          <Row>
                            <Col>
                              <Form>
                                <Row form>
                                  <Col md="12" className="form-group">
                                    <label htmlFor="feAssignedLocations">
                                      <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-2" />
                                      Assigned Locations
                                    </label>
                                    <div className="mb-3">
                                      <FormSelect 
                                        id="feLocationSelect" 
                                        value={selectedLocation} 
                                        onChange={event => setSelectedLocation(event.target.value)}
                                      >
                                        <option value="">Select a location to assign</option>
                                        {props.locations && props.locations
                                          .filter(location => location.active && location.client === client)
                                          .filter(location => !assignedLocations.includes(location.id))
                                          .sort((a, b) => a.name.localeCompare(b.name))
                                          .map(location => (
                                            <option key={location.id} value={location.id}>
                                              {location.name}
                                            </option>
                                          ))
                                        }
                                      </FormSelect>
                                      <Button
                                        size="sm"
                                        theme="primary"
                                        className="mt-2"
                                        disabled={!selectedLocation}
                                        onClick={() => {
                                          if (selectedLocation && !assignedLocations.includes(selectedLocation)) {
                                            setAssignedLocations([...assignedLocations, selectedLocation])
                                            setSelectedLocation('')
                                          }
                                        }}
                                      >
                                        Add Location
                                      </Button>
                                    </div>
                                    
                                    {assignedLocations.length > 0 && (
                                      <div>
                                        <label className="form-label">Currently Assigned:</label>
                                        <div className="d-flex flex-wrap">
                                          {assignedLocations.map(locationId => {
                                            const location = props.locations?.find(loc => loc.id === locationId)
                                            return location ? (
                                              <Badge
                                                key={locationId}
                                                theme="primary"
                                                className="mr-2 mb-2 d-flex align-items-center"
                                                style={{ fontSize: '12px', padding: '6px 10px' }}
                                              >
                                                <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-1" />
                                                {location.name}
                                                <FontAwesomeIcon 
                                                  icon={faTimes} 
                                                  className="ml-2" 
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={() => {
                                                    setAssignedLocations(assignedLocations.filter(id => id !== locationId))
                                                  }}
                                                />
                                              </Badge>
                                            ) : null
                                          })}
                                        </div>
                                      </div>
                                    )}
                                  </Col>
                                </Row>
                              </Form>
                            </Col>
                          </Row>
                        )}
                        
                        <Row>
                          <Col>
                            <Form>
                              <Row form>
                                <Col md="12" className="form-group">
                                <Button
                                  className="mr-1"
                                  theme="secondary"
                                  onClick={() => props.onCancel ? props.onCancel() : window.location.href='/users'}
                                >Cancel</Button>
                                <Button
                                  theme="accent"
                                  disabled={!validName || !validEmail || ((!user || !user.id) && !validPassword) || !client }
                                  onClick={() => {
                                    const userData = {
                                      name,
                                      email,
                                      client,
                                      type,
                                      active,
                                      stripe_refunds: stripeRefunds,
                                      ...(type === 'regional' && { assignedLocations })
                                    };
                                    console.log('Saving user with data:', userData);
                                    if (!!user) {
                                      props.editUser(user, userData, () => window.location.href='/users')
                                    } else {
                                      props.addUser({...userData, password}, () => window.location.href='/users')
                                    }
                                  }}
                                >Save</Button>
                                </Col>
                              </Row>                        
                            </Form>
                          </Col>
                        </Row>
                      </ListGroupItem>
                    </ListGroup>
                  </Col>
                  <Col lg="6"></Col>
                </Row>
              </Container>
            </Card>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default EditUser;
